import { render, staticRenderFns } from "./ImgShadow.vue?vue&type=template&id=4ee52292"
import script from "./ImgShadow.vue?vue&type=script&lang=js"
export * from "./ImgShadow.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/youtube/yt-img-shadow.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports